import TargetEntitiesGrid from './TargetEntitiesGrid';

export default TargetEntitiesGrid;
